import { ComponentRef } from '@angular/core';

export class FormItem {
  selector?: string;
  component!: ComponentRef<unknown>;
  inputs: any;
}
